<script>
export let currentRoute;


import Navbar from 'layouts/my/Navbar.svelte';
import Footer from 'layouts/my/Footer.svelte';
import Loading from 'components/elements/Loading.svelte';
import Error from 'components/elements/Error.svelte';


import { auth, my } from 'store/index.js';


import { Route, navigateTo } from 'svelte-router-spa';
import { onMount } from 'svelte';
import { get } from 'svelte/store';


const api_url = app_.env.API_URL;
const token = get(auth).token;

const params = {};



let loading = true;



const retries_503 = 1;


async function testAccessToken(token) {

	const test_token_url = `${api_url}auth/login/test-token/coach`;

	let resp = await fetch(test_token_url, {
		method: 'POST',
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});

	if (resp.status === 503) {
		for (let i = 0; i < retries_503; i++) {
			// sleep to give server more time...
			await new Promise(r => setTimeout(r, 5000));
			console.log('1');
			resp = await fetch(test_token_url, {
				method: 'POST',
				headers: {
					Authorization: `Bearer ${token}`,
				},
			});
		}
	}

	// const result = await resp.json();

	return resp;
}


// example
// auth.update(state => {
// 	state.role = data.role;
// 	state.email = data.email;
// 	return state;
// });


testAccessToken(token).then(data => {
	if (data.ok) return;
	throw new Error('Could not login!');
}).catch(err => {
	auth.set({token: null});
	navigateTo('/login');
}).finally(() => {
	loading = false;
});

</script>



<style>

#my-layout {
	margin-top: 3.25rem;
	/*navbar-height*/
}

</style>


<!-- Loading... -->
{#if loading}
<Loading is_fullheight={true} />
{:else}
<Navbar />
<div id="my-layout" class="my-layout layout">
	<Route {currentRoute} {params} />
</div>
<!-- <Footer /> -->
{/if}



